import React from 'react';
import PropTypes from 'prop-types';
import ListQuantityFieldHandlers from '../../common/list-quantity-field-handlers';
import NumberInputField from '../number-input-field';

// Bulk Quantity Change Inputs are used to change the quantity of each size, if
// each photo has the same quantity for that size. If the quantities are different
// then the input is blank.
const uniformQuantityForPhotosOrBlank = (rootIds, photos = []) => {
  const initialValue = photos[0] && photos[0].quantity;

  if (!photos.length) return 0;

  // if there are fewer photos for this size than
  // there are altogether then there's not going to
  // be a match
  // deliberately undefined so number field is blank
  if (photos.length < rootIds.length) return '';

  for (let i = 0; i < photos.length; i += 1) {
    // deliberately undefined so number field is blank
    if (photos[i].quantity !== initialValue) return '';
  }

  return initialValue;
};

const BulkQuantityChangeSize = ({
  size_id: sizeId,
  handleQuantityChange,
  disabled,
  title,
  rootIds,
  photos,
}) => {
  const inputID = `bulk-quantity-change-${sizeId}`;
  const inputValue = uniformQuantityForPhotosOrBlank(rootIds, photos);

  return (
    <div className="bulk-quantity-change__size form-inline">
      <div className="form-group flex-nowrap">
        <NumberInputField
          id={inputID}
          min={0}
          max={999}
          disabled={disabled}
          label={title}
          value={inputValue}
          noButtons
          onChange={handleQuantityChange}
          inputClassName="form-control-sm"
        />
        <label htmlFor={inputID}>{title}</label>
      </div>
    </div>
  );
};

BulkQuantityChangeSize.displayName = 'BulkQuantityChangeSize';

BulkQuantityChangeSize.propTypes = {
  size_id: PropTypes.string,
  title: PropTypes.string,
  photos: PropTypes.string,
  rootIds: PropTypes.arrayOf(PropTypes.number),
  disabled: PropTypes.bool,
  handleQuantityChange: PropTypes.func,
}.isRequired;

export default ListQuantityFieldHandlers(BulkQuantityChangeSize);
